import MobileVerify from './MobileVerify';

export default MobileVerify;
